import React, { HTMLInputTypeAttribute } from "react";
import InputTooltip, { placement } from "@/components/general/tooltip";
import styles from "@/components/forms/inputsWithRef/inputWithRef.module.css";
import classNames from "classnames";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
  label?: string | any;
  tooltip?: boolean;
  placement?: placement;
  tooltipMessage?: any;
  autoComplete?: string;
  mandatory?: boolean;
  name: string | undefined;
  required?: boolean;
  onChange: (event: any) => void;
  type?: HTMLInputTypeAttribute;
  htmlType?: HTMLInputTypeAttribute;
  placeholder?: string;
  readonly?: boolean;
  changeColor?: any;
  onFocus?: () => void;
  onBlur?: (event?: any) => void;
  pattern?: any;
  id?: any;
  style?: any;
  disabled?: any;
  className?: string;
  convertToEuro?: boolean;
  // defaultValue?: string;
  min?: any;
  max?: any;
  step?: any;
  value?: any;
  defaultValue?: any;
  accept?: any;
  onWheel?: any;
  labelClassname?: any;
  inputClassname?: any;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  clearable?: boolean;
  onClear?: () => void; //for custom onClearhandling - default onChange("") gets called
  hideLabel?: boolean;
  dataTestId?: string;
}

export const InputWithRef = React.forwardRef<HTMLInputElement, Props>(
  function InputWithRef(props, ref) {
    const mapTypeToInput = () => {
      if (props.htmlType) {
        return { type: props.htmlType, step: props.step };
      }

      switch (props.type) {
        case "int":
          return { type: "number" as const, step: 1 };
        case "float":
          return {
            type: "number" as const,
            step: props.step ? props.step : "any",
          };
        case "file":
          return { type: "file" as const };
        case "text":
        default:
          return { type: "text" as const };
      }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (
        (props.type === "int" || props.type === "float") &&
        ["e", "E", "+", "-"].includes(e.key)
      ) {
        e.preventDefault();
      }
    };

    const inputProps = mapTypeToInput();

    const handleClear = () => {
      if (props.onClear) {
        props.onClear();
      } else if (props.onChange) {
        const event = {
          target: { value: "" },
        } as React.ChangeEvent<HTMLInputElement>;
        props.onChange(event);
      }
    };

    return (
      <div
        className={`${styles.inputContainer} ${props.className}`}
        style={props.style}
      >
        {!props.hideLabel && (
          <label
            className={classNames(styles.label, {
              [styles.labelDisabled]: props.disabled,
              [props.labelClassname]: props.labelClassname,
            })}
            htmlFor={props.name}
          >
            {props.mandatory === true || props.required === true ? (
              <>
                {props.label}
                <span style={{ color: "red" }}>*</span>
              </>
            ) : (
              <span>{props.label}</span>
            )}

            {props.tooltip && (
              <InputTooltip
                tooltipMessage={props.tooltipMessage}
                placement={props.placement}
              />
            )}
          </label>
        )}
        <div className={styles.inputWrapper}>
          <input
            ref={ref}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            className={classNames(styles.inputField, {
              [props.inputClassname]: props.inputClassname,
              [props.changeColor]: styles.inputFieldLightGray,
            })}
            id={props.name}
            // required={props.required}
            onChange={props.onChange}
            name={props.name}
            autoComplete={props.autoComplete}
            disabled={props.disabled}
            placeholder={props.placeholder}
            readOnly={props.readonly}
            min={props.min}
            max={props.max}
            type={inputProps.type}
            step={inputProps.step}
            onKeyDown={handleKeyDown}
            onWheel={props.onWheel}
            // type={props.type}
            accept={props.accept}
            inputMode={props.inputMode}
            data-testid={props.dataTestId}
            {...(props.value === undefined &&
              props.defaultValue !== undefined && {
                defaultValue: props.defaultValue,
              })}
            {...(props.value !== undefined && { value: props.value })}
          />
          {props.clearable && props.value != null && props.value !== "" && (
            <GenericButton
              variant="icon"
              color="iconBase"
              className={styles.clearButton}
              onClick={handleClear}
            >
              <ClearIcon />
            </GenericButton>
          )}
        </div>
      </div>
    );
  },
);
